import { render, staticRenderFns } from "./CoinSelect.vue?vue&type=template&id=dc1ec8f6&scoped=true&"
import script from "./CoinSelect.vue?vue&type=script&lang=js&"
export * from "./CoinSelect.vue?vue&type=script&lang=js&"
import style0 from "./CoinSelect.vue?vue&type=style&index=0&id=dc1ec8f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1ec8f6",
  null
  
)

export default component.exports